import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
import { ArticleCardStyles } from '../ArticleCard/ArticleCard.styles';
import { CtaCardStyles } from '../CtaCard/CtaCard.styles';
import { InformationCardStyles } from '../InformationCard/InformationCard.styles';
const Container = styled(ArticleCardStyles.Container) `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ImageWrapper = styled(ArticleCardStyles.ImageWrapper) ``;
const CategoryTag = styled(ArticleCardStyles.CategoryTag) ``;
const Image = styled(ArticleCardStyles.Image) ``;
const CardContent = styled(InformationCardStyles.Content) `
  position: relative;
  padding-bottom: 79px;

  ${Container}[data-memberOnlyContent=true] & {
    padding-bottom: 20px;
  }

  ${Container}[data-featured] & {
    background-color: var(--themeColor);
    padding: 20px 30px 79px;
  }

  ${Container}[data-featured][data-memberOnlyContent=true] & {
    background-color: var(--themeColor);
    padding: 20px 30px 0;
  }
`;
const Title = styled(ArticleCardStyles.Title) ``;
const Content = styled.p `
  ${paragraphSmall};
  margin-bottom: 10px;

  ${Container}[data-featured] & {
    color: ${brand.white};
  }
`;
const ArticleInfo = styled.div ``;
const ArticleInfoItem = styled(ArticleCardStyles.ArticleInfoItem) ``;
const ArticleInfoItemIcon = styled.div `
  display: flex;
  align-items: center;
  width: 16px;
  margin-right: 7px;
`;
const ArrowIcon = styled(CtaCardStyles.ArrowIcon) `
  top: auto;
  bottom: 10px;
  right: 15px;

  @media ${from(Device.MobileLarge)} {
    top: auto;
    bottom: 10px;
    right: 20px;

    ${Container}[data-featured] & {
      bottom: 20px;
      right: 30px;
    }
  }

  ${Container}[data-featured] & {
    background-color: ${brand.white};

    svg {
      path:first-child {
        stroke: var(--themeColor);
      }
    }
  }
`;
const MemberOnlyContent = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;
  padding: 10px ${fluid(15, 20)};
  color: ${brand.white};
  text-transform: uppercase;
  background-color: var(--themeColor);

  > span {
    ${fonts.agBook.regular};
    font-size: ${fluid(16, 18)};
    line-height: ${fluid(19, 22)};
    margin-left: ${fluid(12, 32)};
  }

  ${ArrowIcon} {
    position: relative;
    bottom: auto;
    right: auto;
    background-color: ${brand.white};

    @media ${from(Device.MobileLarge)} {
      top: auto;
      bottom: auto;
    }

    svg {
      path {
        &:first-child {
          stroke: var(--themeColor);
        }
      }
    }
  }

  ${Container}[data-featured] & {
    width: calc(100% + 60px);
    margin-left: -30px;
    padding: 10px 30px;
    background-color: ${brand.white};
    color: var(--themeColor);

    ${ArrowIcon} {
      position: relative;
      bottom: auto;
      right: auto;
      background-color: var(--themeColor);

      svg {
        path {
          &:first-child {
            stroke: ${brand.white};
          }
        }
      }
    }
  }
`;
export const ResourceCardStyles = {
    ArrowIcon,
    CardContent,
    CategoryTag,
    Container,
    Content,
    ArticleInfo,
    ArticleInfoItem,
    ArticleInfoItemIcon,
    Image,
    ImageWrapper,
    MemberOnlyContent,
    Title,
};
